import Vue from 'vue'

const nameMap = {
  'AdRevenueQuery': '广告收入',
  'FullReportManagement': '报表管理',
  'SystemConfigManagement': '系统配置',
  'AppInfoManagement': 'App信息管理',
  'DisplayImageManagement': '展示图管理',
  'UserManagement': '用户管理',
  'UserWithdrawalManagement': '用户提现',
  'AdminManagement': '管理员管理',
  'GoodsManagement': '商品管理',
  'GoodsCategoryManagement': '分类管理',

  'RiskManagement': '风控管理',
  'CoinFlowManagement': '金币明细',
  'NoticeSendManagement': '消息通知',
  'AgentNoticeManagement': '消息通知'
}

export function getHomePath() {
  const role = parseInt(localStorage.getItem('role')) || 0
  if (role === 1 || role === 2) return '/user-management'
  return '/ad-revenue'
}

function getHomeTitle() {
  return getHomePath() === '/ad-revenue' ? '广告收入' : '用户管理'
}

function getPageTitle(route) {
  if (route.meta && route.meta.title) return route.meta.title
  if (route.name && nameMap[route.name]) return nameMap[route.name]
  return route.name || route.path
}

function formatView(route) {
  return {
    path: route.path,
    name: route.name,
    title: getPageTitle(route),
    query: route.query ? { ...route.query } : {},
    fullPath: route.fullPath
  }
}

const state = Vue.observable({
  visitedViews: [],
  cachedViews: []
})

function addView(route) {
  if (!route || !route.name) return
  if (route.path === '/login' || route.path === '/') return
  if (route.name === 'DataDashboard') return

  const view = formatView(route)
  const exists = state.visitedViews.some(v => v.path === view.path)

  if (!exists) {
    state.visitedViews.push(view)
  }
}

function removeView(view) {
  for (let i = state.visitedViews.length - 1; i >= 0; i--) {
    if (state.visitedViews[i].path === view.path) {
      state.visitedViews.splice(i, 1)
      break
    }
  }
}

function closeOthers(view) {
  const homePath = getHomePath()
  state.visitedViews = state.visitedViews.filter(
    v => v.path === view.path || v.path === homePath
  )
}

function closeAll() {
  const homePath = getHomePath()
  state.visitedViews = state.visitedViews.filter(
    v => v.path === homePath
  )
}

function toLastView(currentRoute) {
  const latestView = state.visitedViews.slice(-1)[0]
  if (latestView && latestView.fullPath !== currentRoute.fullPath) {
    return latestView
  }
  return null
}

function isFixedHome(path) {
  return path === getHomePath()
}

export default {
  get visitedViews() {
    return state.visitedViews
  },
  get cachedViews() {
    return state.cachedViews
  },
  addView,
  removeView,
  closeOthers,
  closeAll,
  toLastView,
  isFixedHome,
  getPageTitle,
  getHomePath,
  get fixedHomePath() {
    return getHomePath()
  },
  get fixedHomeTitle() {
    return getHomeTitle()
  }
}
